export const MAX_LIMIT_SYMBOL_LENGTH = 1500;
